import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { FeedEntryTypesProvider as Provider } from '../../components/context/feed-entry-types-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllFeedEntryTypesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "FeedEntryTypes" } }) {
    nodes {
      data
    }
  }
}
`;

export const FeedEntryTypesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};
